export default {
  "home": "首页",
  "categories": "影片分类",
  "about": "关于我们",
  "search": "搜索影片...",
  "watch_now": "立即观影",
  "learn_more": "了解更多",
  "more_recommend": "更多推荐",
  "more_shows": "更多剧集",
  "subscribe": "立即订阅",
  "all_rights_reserved": "版权所有",
  "privacy_policy": "隐私政策",
  "terms_of_service": "服务条款",
  "cookie_settings": "Cookie设置",
  "play_help": "播放帮助",
  "feedback": "意见反馈",
  "disclaimer": "免责声明",
  "quick_links": "快速链接",
  "contact_us": "联系我们",
  "customer_service": "24小时在线客服",
  "back_to_top": "回到顶部",
  "daily_update": "每日更新 200+ 高清影片",
  "hero_title": "蓝光画质零缓冲畅享观影新体验",
  "hero_subtitle": "海量高清电影和热门电视剧实时更新，超清剧场任你选。专注提供稳定流畅不卡顿的观影服务，让每一帧画面都清晰动人。",
  "featured_title": "推荐电影精选",
  "featured_subtitle": "精心挑选的高分佳片，每一部都值得细细品味",
  "tv_title": "热门剧集推荐",
  "tv_subtitle": "高分热门电视剧，追剧达人的不二之选",
  "faq_title": "常见问题",
  "faq_subtitle": "关于观看体验的常见疑问，这里都有答案",
  "cta_title": "不错过任何精彩内容",
  "cta_subtitle": "订阅我们的更新通知，第一时间获取最新上映的高清电影和热门剧集推送。",
  "cta_placeholder": "输入您的邮箱地址",
  "cta_success": "订阅成功！感谢您的关注",
  "cta_loading": "订阅中..."
};